import { NoteDto } from '../services/bpp.webapi/client';

export function isNonEmptyNotes(notes: NoteDto) {
    return notes && notes.message && notes.message.length > 0;
}
